<template>
    <div>
        <el-dialog :visible.sync="dialogVisible" :title="ruleData.ruleName" width="90%">
            <!-- 规则信息 -->
            <el-descriptions :column="1" size="medium" border>
                <template #title>
                    <div style="display: flex; align-items: center;">
                        {{ ruleData.ruleName }}
                        <el-tag style="margin-left: 10px"
                                size="small"
                                :type="statusTag.type"
                        >
                            {{ statusTag.text }}
                        </el-tag>
                    </div>
                </template>
                <el-descriptions-item label="规则编码">
                    {{ ruleData.ruleCode }}
                </el-descriptions-item>

                <el-descriptions-item label="规则描述">
                    {{ ruleData.ruleDescription || '无' }}
                </el-descriptions-item>

                <el-descriptions-item v-if="ruleData.auditDetails" label="审核详情">
                    <div
                        v-for="(detail, index) in formatAuditDetails(ruleData.auditDetails)"
                        :key="index"
                        class="audit-detail-item"
                    >
                        {{ detail }}
                    </div>
                </el-descriptions-item>

                <el-descriptions-item v-else label="审核详情">
                    暂无审核详情
                </el-descriptions-item>
            </el-descriptions>

            <!-- 文件预览对比区：左右并列 -->
            <div class="file-preview-container" style="display: flex; margin-top: 20px; height: 70vh;">

                <!-- 左侧：被检文件列表 -->
                <div class="side-panel"
                     style="flex: 1; display: flex; border: 1px solid #dcdfe6; border-radius: 8px; overflow: hidden; margin-right: 10px;">
                    <!-- 文件列表 -->
                    <div class="file-list"
                         style="width: 100px; background: #f5f7fa; padding: 10px 0; overflow-y: auto;">
                        <div
                            v-for="(file, index) in checkedFiles"
                            :key="file.id || index"
                            class="file-item"
                            :class="{ active: currentLeftFile === file }"
                            @click="showLeftFile(file)"
                            style="padding: 8px; cursor: pointer; text-align: center; font-size: 12px;"
                        >
                            <!-- 图标 -->
                            <el-image
                                v-if="isImage(file.ossUrl)"
                                :src="file.ossUrl"
                                fit="cover"
                                style="width: 40px; height: 40px; margin: 0 auto;"
                            >
                                <div slot="error" class="image-slot">
                                    <img :src="require('@/assets/images/i_img.png')"
                                         style="width: 40px; height: 40px;"/>
                                </div>
                            </el-image>

                            <el-image
                                v-else-if="isPdf(file.ossUrl)"
                                :src="require('@/assets/images/pdf.png')"
                                fit="cover"
                                style="width: 40px; height: 40px; margin: 0 auto;"
                            />
                            <el-image
                                v-else-if="isZip(file.ossUrl)"
                                :src="require('@/assets/images/zip.png')"
                                fit="cover"
                                style="width: 40px; height: 40px; margin: 0 auto;"
                            />
                            <el-image
                                v-else-if="isPpt(file.ossUrl)"
                                :src="require('@/assets/images/ppt.png')"
                                fit="cover"
                                style="width: 40px; height: 40px; margin: 0 auto;"
                            />
                            <el-image
                                v-else-if="isDoc(file.ossUrl)"
                                :src="require('@/assets/images/doc.png')"
                                fit="cover"
                                style="width: 40px; height: 40px; margin: 0 auto;"
                            />
                            <el-image
                                v-else-if="isXls(file.ossUrl)"
                                :src="require('@/assets/images/xls.png')"
                                fit="cover"
                                style="width: 40px; height: 40px; margin: 0 auto;"
                            />
                            <el-image
                                v-else
                                :src="require('@/assets/images/i_file.svg')"
                                fit="cover"
                                style="width: 40px; height: 40px; margin: 0 auto;"
                            />

                            <!-- 文件名 -->
                            <div style="margin-top: 5px; word-break: break-word; font-size: 11px; color: #666;">
                                <!--                             {{ truncateFileName(file.fileName) }}-->
                                {{ file.fileName }}
                            </div>
                        </div>
                    </div>

                    <!-- 预览区 -->
                    <div class="preview-area" style="flex: 1; background: #fff;">
                        <iframe
                            v-if="currentLeftFile"
                            :src="previewLeftSrc"
                            :key="previewLeftSrc"
                            frameborder="0"
                            style="width: 100%; height: 100%;"
                        ></iframe>
                        <div v-else
                             style="display: flex; align-items: center; justify-content: center; height: 100%; color: #999;">
                            请选择左侧文件预览
                        </div>
                    </div>
                </div>

                <!-- 右侧：参考文件（如合同、协议等） -->
                <div class="side-panel"
                     style="flex: 1; display: flex; border: 1px solid #dcdfe6; border-radius: 8px; overflow: hidden;">
                    <div class="file-list"
                         style="width: 100px; background: #f5f7fa; padding: 10px 0; overflow-y: auto;">
                        <div
                            v-for="(refFile, index) in referenceFiles"
                            :key="refFile.id || index"
                            class="file-item"
                            :class="{ active: currentRightFile === refFile }"
                            @click="showRightFile(refFile)"
                            style="padding: 8px; cursor: pointer; text-align: center; font-size: 12px;"
                        >
                            <el-image
                                v-if="isImage(refFile.ossUrl)"
                                :src="refFile.ossUrl"
                                fit="cover"
                                style="width: 40px; height: 40px; margin: 0 auto;"
                            >
                                <div slot="error" class="image-slot">
                                    <img :src="require('@/assets/images/i_img.png')"
                                         style="width: 40px; height: 40px;"/>
                                </div>
                            </el-image>

                            <el-image
                                v-else-if="isPdf(refFile.ossUrl)"
                                :src="require('@/assets/images/pdf.png')"
                                fit="cover"
                                style="width: 40px; height: 40px; margin: 0 auto;"
                            />
                            <el-image
                                v-else-if="isDoc(refFile.ossUrl)"
                                :src="require('@/assets/images/doc.png')"
                                fit="cover"
                                style="width: 40px; height: 40px; margin: 0 auto;"
                            />
                            <el-image
                                v-else
                                :src="require('@/assets/images/i_file.svg')"
                                fit="cover"
                                style="width: 40px; height: 40px; margin: 0 auto;"
                            />

                            <div style="margin-top: 5px; word-break: break-word; font-size: 11px; color: #666;">
                                {{ truncateFileName(refFile.fileName) }}
                            </div>
                        </div>
                    </div>

                    <!-- 预览区 -->
                    <div class="preview-area" style="flex: 1; background: #fff;">
                        <iframe
                            v-if="currentRightFile"
                            :src="previewRightSrc"
                            :key="previewRightSrc"
                            frameborder="0"
                            style="width: 100%; height: 100%;"
                        ></iframe>
                        <div v-else
                             style="display: flex; align-items: center; justify-content: center; height: 100%; color: #999;">
                            请选择右侧参考文件预览
                        </div>
                    </div>
                </div>
            </div>


        </el-dialog>
    </div>
</template>

<script>
import {Base64} from 'js-base64';

export default {
    props: {
        // // 接收单个规则对象
        // rule: {
        //     type: Object,
        //     required: true
        // }
    },
    data() {
        return {
            dialogVisible: false,
            ruleData: {
                ruleName: ""
            },
            currentLeftFile: null,
            currentRightFile: null
        };
    },
    computed: {
        isPassed() {
            return this.ruleData.auditResult === 1;
        },
        checkedFiles() {
            console.log("checkedFileList", this.ruleData)
            return this.ruleData.checkedFileList || [];
        },
        referenceFiles() {
            return this.ruleData.referenceFileList || [];
        },
        previewLeftSrc() {
            if (!this.currentLeftFile) return '';
            const encodedUrl = encodeURIComponent(Base64.encode(this.currentLeftFile.ossUrl));

            if (/\.(pdf)$/i.test(this.currentLeftFile.ossUrl.split('?')[0])) {
                return `https://wmzh.life-oasis.com/kkFileView/onlinePreview?url=${encodedUrl}` + "&officePreviewType=pdf";
            }
            return `https://wmzh.life-oasis.com/kkFileView/onlinePreview?url=${encodedUrl}`;
        },
        previewRightSrc() {
            if (!this.currentRightFile) return '';
            const encodedUrl = encodeURIComponent(Base64.encode(this.currentRightFile.ossUrl));

            if (/\.(pdf)$/i.test(this.currentRightFile.ossUrl.split('?')[0])) {
                return `https://wmzh.life-oasis.com/kkFileView/onlinePreview?url=${encodedUrl}` + "&officePreviewType=pdf";
            }
            return `https://wmzh.life-oasis.com/kkFileView/onlinePreview?url=${encodedUrl}`;

        },
        statusTag() {
            const result = this.ruleData?.auditResult;

            switch (result) {
                case 1:
                    return {type: 'success', text: '通过'};
                case 2:
                    return {type: 'danger', text: '不通过'};
                case 0:
                    return {type: 'warning', text: '待审核'};
                case 3:
                    return {type: 'info', text: '未接入'};
                default:
                    return {type: 'info', text: '未接入'};
            }
        }
    },
    methods: {
        open(rule) {
            console.log("dakai", rule)
            this.dialogVisible = true;
            this.$nextTick(() => {
                // 先清空当前文件，防止 iframe 缓存
                this.currentLeftFile = null;
                this.currentRightFile = null;

                // 再设置新数据
                this.ruleData = rule;
                // 默认选中第一个文件
                // 延迟设置默认文件，确保 iframe 销毁后再重建
                this.$nextTick(() => {
                    if (this.checkedFiles.length > 0) {
                        this.currentLeftFile = this.checkedFiles[0];
                    }
                    if (this.referenceFiles.length > 0) {
                        this.currentRightFile = this.referenceFiles[0];
                    }
                });
            });

        },

        showLeftFile(file) {
            this.currentLeftFile = file;
        },
        showRightFile(file) {
            this.currentRightFile = file;
        },

        // 处理 auditDetails 字段：可能是字符串或数组
        formatAuditDetails(details) {
            if (!details) return [];
            if (Array.isArray(details)) return details;
            if (typeof details === 'string') {
                return details.split('\n').filter(d => d.trim());
            }
            return [String(details)];
        },

        // 文件名截断显示
        truncateFileName(name, len = 8) {
            if (!name) return '';
            return name.length > len ? name.slice(0, len) + '...' : name;
        },

        // 文件类型判断
        isImage(url) {
            return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
        },
        isPdf(url) {
            return /\.pdf$/i.test(url);
        },
        isDoc(url) {
            return /\.(doc|docx)$/i.test(url);
        },
        isXls(url) {
            return /\.(xls|xlsx)$/i.test(url);
        },
        isPpt(url) {
            return /\.(ppt|pptx)$/i.test(url);
        },
        isZip(url) {
            return /\.(zip|rar|7z|tar|gz)$/i.test(url);
        }
    }
};
</script>

<style scoped>
.file-item.active {
    background-color: #ecf5ff;
    color: #409eff;
    border-left: 3px solid #409eff;
}

.audit-detail-item {
    line-height: 1.6;
    color: #666;
    font-size: 14px;
}
</style>
